<template>
    <svg width="24" height="25" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
            fill="url(#paint0_linear_8_3468)" />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M3.62131 7.91596C5.95347 6.89987 7.50862 6.22999 8.28672 5.90637C10.5084 4.98231 10.9701 4.82177 11.2709 4.81646C11.3371 4.81531 11.4851 4.83171 11.5809 4.90949C11.7231 5.02487 11.7239 5.27531 11.7082 5.44106C11.5877 6.70606 11.0668 9.77584 10.8018 11.1926C10.6896 11.7922 10.4688 11.9932 10.2551 12.0128C9.7905 12.0556 9.43772 11.7058 8.98775 11.4109C8.28365 10.9493 7.88587 10.662 7.2024 10.2116C6.41256 9.69112 6.92459 9.40506 7.37472 8.93752C7.49253 8.81518 9.53944 6.95334 9.57906 6.78443C9.58403 6.76331 9.58862 6.68456 9.54184 6.64299C9.49506 6.60143 9.42603 6.61562 9.37622 6.62693C9.30559 6.64296 8.18078 7.38643 6.00178 8.85731C5.6825 9.07656 5.39331 9.18337 5.13422 9.17777C4.84856 9.17162 4.29912 9.01627 3.89065 8.88349C3.38965 8.72065 2.99147 8.63452 3.02615 8.35796C3.04422 8.21387 3.24259 8.06656 3.62131 7.91596Z"
              fill="white" />
        <defs>
            <linearGradient id="paint0_linear_8_3468" x1="8" y1="0" x2="8" y2="15.875" gradientUnits="userSpaceOnUse">
                <stop stop-color="#2AABEE" />
                <stop offset="1" stop-color="#229ED9" />
            </linearGradient>
        </defs>
    </svg>
</template>
<script>
export default {
    name: "TelegramIcon",
};
</script>
<style scoped></style>